import { useURLParams } from '../../contexts/ParamsContext';
import GroupList from '../pages/GroupList';
import PostTypeList from '../pages/PostTypeList';
import TaxonomyList from '../pages/TaxonomyList';
import GroupEdit from '../pages/GroupEdit';
import PostTypeEdit from '../pages/PostTypeEdit';
import TaxonomyEdit from '../pages/TaxonomyEdit';
import OptionPageEdit from '../pages/OptionPageEdit';
import OptionPageList from '../pages/OptionPageList';
import Tools from '../pages/Tools';

const MainContentArea = () => {

    const { params, updateUrlParams } = useURLParams();

    return (
        <>
            {params.view === 'edit-group' || params.view === 'new-group' ? (
                <GroupEdit />
            ) : params.view === 'edit-post-type' || params.view === 'new-post-type' ? (
                <PostTypeEdit />
            ) : params.view === 'edit-taxonomy' || params.view === 'new-taxonomy' ? (
                <TaxonomyEdit />
            ) : params.view === 'edit-options-page' || params.view === 'new-options-page' ? (
                <OptionPageEdit />
            ) : params.view === 'tools' ? (
                <Tools />
            ) : params.view === 'taxonomies' ? (
                <TaxonomyList />
            ) : params.view === 'post-types' ? (
                <PostTypeList />
            ) : params.view === 'options-pages' ? (
                <OptionPageList />
            ) : (
                <GroupList />
            )}
        </>
    );
};

export default MainContentArea;
